// extracted by mini-css-extract-plugin
export default {"container":"Clock_container__-dNyX","message":"Clock_message__w9FRs","clock":"Clock_clock__1xoNe","date":"Clock_date__Yc7ef"};